/***************************************************************************************************
 ** Add Custom Turbo Stream Actions
 ***************************************************************************************************/

import { StreamActions } from "@hotwired/turbo";
import toast from "@utils/toast";

StreamActions.redirect_to = function () {
  const url = this.getAttribute("url") || "/";

  Turbo.visit(url);
};

StreamActions.toast = function () {
  const message = this.getAttribute("message") || "";

  toast(message, {
    type: this.getAttribute("type"),
    duration: this.getAttribute("duration"),
  });
};

StreamActions.scroll_to = function () {
  const target = this.getAttribute("target");
  const behavior = this.getAttribute("behavior") || "smooth";
  const block = this.getAttribute("block") || "start";

  requestAnimationFrame(() => {
    const element = document.getElementById(target);

    if (element) {
      element.scrollIntoView({ behavior, block });
    }
  });
};

StreamActions.reload_frame = function () {
  const target = this.getAttribute("target");
  const frame = document.getElementById(target);

  if (frame && typeof frame.reload === "function") {
    frame.reload();
  } else {
    console.error(`[turbo-stream:reload_frame] Turbo Frame not found for target id: ${target}`);
  }
};

StreamActions.disable = function () {
  const target = this.getAttribute("target");
  const element = document.getElementById(target);

  if (element) {
    element.disabled = true;
  } else {
    console.error(`[turbo-stream:disable] Element not found for target id: ${target}`);
  }
};

StreamActions.enable = function () {
  const target = this.getAttribute("target");
  const element = document.getElementById(target);

  if (element) {
    element.disabled = false;
  } else {
    console.error(`[turbo-stream:enable] Element not found for target id: ${target}`);
  }
};
